import { createSlice } from '@reduxjs/toolkit';
import { jwtDecode } from 'jwt-decode';

// Try to read token and decode user from localStorage
const rawToken = localStorage.getItem('authToken');
let initialUser = null;

if (rawToken) {
  try {
    initialUser = jwtDecode(rawToken);
  } catch (e) {
    console.warn('Invalid authToken, clearing from storage', e);
    localStorage.removeItem('authToken');
  }
}

const initialState = {
  user: initialUser,
  token: rawToken,
  isAuthenticated: !!rawToken,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginSuccess: (state, action) => {
      state.token = action.payload.token;
      state.user = action.payload.user;
      state.isAuthenticated = true;
      localStorage.setItem('authToken', action.payload.token);
    },
    logout: (state) => {
      state.token = null;
      state.user = null;
      state.isAuthenticated = false;
      localStorage.removeItem('authToken');
    },
    updateUser: (state, action) => {
      state.user = action.payload;
    },
  },
});

export const { loginSuccess, logout, updateUser  } = authSlice.actions;
export default authSlice.reducer;
